import config from '../../config';
import { isNonEmptyString, navigateToExternal } from '../../core/util';
import { deleteJourneyProfile } from '../../flows/shared/services/profile-service';
import { modalCloseHandler } from '../Modal/utils';

export const handleBuyFlowRouting = async (
  profileApplicationID: string
): Promise<any> => {
  try {
    if (isNonEmptyString(profileApplicationID)) {
      await deleteJourneyProfile(profileApplicationID);
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
  }
  modalCloseHandler();
  navigateToExternal(
    `${config('returnUrlPrefix')}usis/transactions/buy?productType=MutualFund`
  );
};

export const handleAccountAccessRouting = async (
  profileApplicationID: string
): Promise<any> => {
  try {
    if (isNonEmptyString(profileApplicationID)) {
      await deleteJourneyProfile(profileApplicationID);
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
  }
  modalCloseHandler();
  navigateToExternal(
    `${config('returnUrlPrefix')}usis/client-portal/dashboard`
  );
};

export const filterAgreementOwners = (
  agremmentParties: any[] | undefined | null,
  isMinorAccount: boolean
): any => {
  if (!agremmentParties) return false;
  let filteredOwners;

  filteredOwners = isMinorAccount
    ? agremmentParties
        ?.filter(owner => owner?.role === 'MINR')
        ?.map(owner => owner?.name?.fullName)
    : agremmentParties
        ?.filter(owner => !owner?.primaryParty)
        ?.map(owner => owner?.name?.fullName);

  // if filter owners array length is greater than one then add prefix space with `and` text
  // for last index element
  if (filteredOwners?.length > 1) {
    filteredOwners = filteredOwners?.map((name, index, array) => {
      if (index === array.length - 1) {
        return ` and ${name}`;
      }
      return ` ${name}`;
    });
  }

  return filteredOwners;
};
